import { Record, List } from "immutable";

export const Admin = Record({
  searchResults: List(),
});
